export default __webpack_public_path__ + "static/media/baseline-close-24px.836230d6.svg";